import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Checkout = styled.div`
  padding: 8px 22px 22px 22px;
`;

export const ConfirmButton = styled(Button)`
  font-size: 16px;
  height: 56px;
  margin-top: 16px;
  position: fixed;
  bottom: 0;
  right: 0;

  @media ${({ theme }) => theme.device.mobile} {
    margin-bottom: 0px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
`;

export const ChurnContainer = styled.div`
  text-align: center;
`;

export const ChurnTitle = styled.h1`
  font-size: 20px;
  line-height: 24px;
  color: ${ColorPalette.HEX.PineTree2};
  text-align: center;
  max-width: 70%;
  margin: 0 auto 24px auto;
`;

export const ChurnDetail = styled.h2`
  font-size: 16px;
  color: ${ColorPalette.HEX.DimGray2};
  text-align: center;
  line-height: 22px;
  font-weight: normal;
  max-width: 90%;
  margin: 0 auto 40px auto;
`;

export const SupportAvatar = styled.img`
  width: 88px;
  height: auto;
  margin: 40px auto;
`;

export const CancelButton = styled.button`
  background: none;
  border: none;

  width: 100%;
  height: 50px;

  color: ${ColorPalette.HEX.PineTree};
  font-size: 16px;
  font-weight: bold;
  text-align: center;

  margin-top: 16px;
  cursor: pointer;
`;
